import React from 'react'
//import { Link } from 'react-router-dom'
import { HashLink as Link} from 'react-router-hash-link'
import { isAuthenticated, logout, isAuthorized } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import AceEditor from 'react-ace';

import 'brace/mode/java';
import 'brace/theme/monokai';


export default class GettingStarted extends React.Component{

  logout() {
    logout()
    this.setState({ loggedOut: true })


  }


render() {
let email;
let authenticationParams = {redirectUri: "${authenticationParams.redirectUri}",
clientId: "authenticationParams.clientId"}

  return (
  <div>
    <div className="Logo">
        <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
        <Link className="home-link" to='/'>Developer</Link>
    </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/updates'>Updates</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>


        <div className="right">
          {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
          {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
        </div>

            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>


      <div className="App-banner">

        <span className="orange-bold"> NEWFORMA CONNECTED </span> 

      </div>



      <div className="content2">

        <div className="content-wrap-no-padding">

                  <div className="left-col">
                  <h1 className="left-col-heading">Legacy API Setup</h1>
                  <ul className="left-col-ul">
                    <li><a className="doc-link-welcome" href="#introduction">Authentication</a></li>
                    <li><a className="doc-link" href="#service">Service to Service Auth</a></li>
                    <li><a className="doc-link" href="#user">User to Service Authentication</a></li>
                    { isAuthorized() ? (<li><a className="doc-link" href="#contructex">ContructEx Authentication</a></li>) : ''}
                    <li><a className="doc-link" href="#example">Code Examples</a></li>

                  </ul>

                  </div>

                      <div className="right-col">

                      </div>

        </div>
        </div>
        </div>


)}}



/** WEBPACK FOOTER **
 ** ./src/pages/LegacySetup/index.js
 **/